import MaskedInput from '@app/components/MaskedInput';
import { IconButton } from '@material-ui/core';
import styled from 'styled-components';

export const InputBox = styled.div`
  position: relative;
  border-radius: 4px;
`;

export const FetchingLabel = styled.span`
  color: #999;
  font-size: 14px;
  margin-top: -6px;
  padding: 3px 0;
`;

export const Input = styled(MaskedInput)`
  width: 100%;
  height: 100%;
  border: 1px solid #c3d0dd;
  border-radius: 4px;
  height: 50px;
  font-size: 14px;
  font-family: var(--font-family);
  padding: 14px;
`;

export const ClearButton = styled(IconButton)`
  position: absolute !important;
  top: 0px;
  right: 5px;
`;
